<template>
  <div class="container">
    <div
      class="d-flex flex-wrap flex-lg-row flex-column align-items-lg-center justify-content-lg-between w-100"
      :class="[
        {
          'justify-content-between':
            $route.path.includes('step1') || $route.path.includes('step2'),
        },
      ]"
    >
      <div>
        <h1
          class="font-weight-bolder mb-0"
          v-if="$route.path.includes('step1') || $route.path.includes('step2')"
        >
          {{
            $route.path.includes("step1")
              ? "Partnership Plans"
              : $route.path.includes("step2")
              ? "register as a partner"
              : ""
          }}
        </h1>
      </div>
      <div
        class="d-flex flex-wrap col-lg-6 py-2 justify-content-between align-items-center"
      >
        <div class="col-md-4 col-12 px-0 pt-md-0 pt-2">
          <b-link
            router-tag="div"
            class="cursor-pointer text-white"
            :to="{ name: 'partner-registration-step1' }"
          >
            <div
              :class="[
                'rounded-circle',
                $route.path.includes('step1') ||
                $route.path.includes('step2') ||
                $route.path.includes('step3')
                  ? 'bg-register-gradient-info'
                  : 'bg-register-gradient-danger',
              ]"
              style="height: 80px; width: 80px"
            >
              <span
                class="font-weight-bolder display-4 px-2 mb-0"
                style="line-height: 5.5rem"
                >1.</span
              >
              <br />
              <span class="font-weight-bolder cell-fit pl-3"
                >select your suitable plan</span
              >
            </div>
          </b-link>
        </div>
        <div class="col-md-4 col-12 px-0 pt-md-0 pt-2">
          <b-link
            router-tag="div"
            class="cursor-pointer text-white"
            :to="{ name: 'partner-registration-step2' }"
          >
            <div
              style="height: 80px; width: 80px"
              :class="[
                'rounded-circle ml-md-4',
                $route.path.includes('step2') || $route.path.includes('step3')
                  ? 'bg-register-gradient-info'
                  : 'bg-register-gradient-danger',
              ]"
            >
              <span
                class="font-weight-bolder display-4 px-2 mb-0"
                style="line-height: 5.5rem"
                >2.</span
              >
              <br />
              <span class="font-weight-bolder cell-fit pl-3"
                >complete your profile</span
              >
            </div>
          </b-link>
        </div>
        <div class="col-md-4 col-12 px-0 pt-md-0 pt-2">
          <b-link
            router-tag="div"
            class="cursor-pointer text-white"
            :to="{ name: 'partner-registration-step3' }"
          >
            <div
              style="height: 80px; width: 80px"
              :class="[
                'rounded-circle ml-md-4',
                $route.path.includes('step3')
                  ? 'bg-register-gradient-info'
                  : 'bg-register-gradient-danger',
              ]"
            >
              <span
                class="font-weight-bolder display-4 px-2 mb-0"
                style="line-height: 5.5rem"
                >3.</span
              >
              <br />
              <span class="font-weight-bolder cell-fit pl-3"
                >verify your account</span
              >
            </div>
          </b-link>
        </div>
      </div>
    </div>
    <div>
      <transition name="fade" mode="out-in">
        <router-view @getProfile="check" />
      </transition>
    </div>
    <!-- <div class="w-100" style="height: 100px">
      <b-img
        fluid
        :src="require('@/assets/images/fxlegends/sample-partners.png')"
        style="max-height: 100px"
      />
    </div> -->
  </div>
</template>

<script>
import { BLink, BImg } from "bootstrap-vue";
export default {
  components: {
    BLink,
    BImg,
  },
  data() {
    return {
      plan: {},
    };
  },
  async created() {
    await this.check();
  },
  mounted() {
    if (this.userData.status == "REJECTED") {
      window.scrollTo(0, document.body.scrollHeight);
    }
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData;
    },
    documents() {
      return this.userData.documents;
    },
  },
  watch: {
    plan(val) {
      if (val) {
        this.$router.push("/partner-registration/step2").catch((err) => {});
      }
    },
    $route: {
      handler(val) {
        // if (this.plan_id) {
        //   this.$router.push("/partner-registration/step2").catch((err) => {});
        // } else {
        // this.$router.push("/partner-registration/step1").catch((err) => {});
        // }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async logout() {
      // Remove userData from localStorage
      try {
        const { data } = await this.$http.post("auth/user/logout");
        await localStorage.removeItem("userData");
        await this.$store.dispatch("auth/setUserData", {});
        await localStorage.removeItem("token");
        this.$http.defaults.headers.common["Authorization"] = await ``;
        // Redirect to login page
        this.$router.push({ name: "auth-user-login" });
      } catch (err) {}
    },
    async check(type) {
      await this.getProfile();
      let status = this.userData.status;
      if (status == "DEACTIVE") {
        this.logout();
      }
      let notOtherDocuments = this.documents.filter(
        (document) => document.type != "OTHER"
      );
      let documentsNotCompleted = notOtherDocuments.length !== 3;
      let hasPendingDocs =
        this.documents.findIndex(
          (document) => document.status == "PENDING" && document.type != "OTHER"
        ) > -1;
      let hasRejectedDocs =
        this.documents.findIndex(
          (document) =>
            document.status == "REJECTED" && document.type != "OTHER"
        ) > -1;
      if (status == "ACCEPTED") {
        this.$router.push({ name: "partner-dashboard" }).catch((err) => {});
      }
      if (type) {
        if (hasPendingDocs) {
          this.$swal({
            icon: "warning",
            title: "Your documents are being reviewed",
          });
        }
        if (documentsNotCompleted) {
          this.$swal({
            icon: "warning",
            title: "Please upload the requirement documents",
          });
        }
        if (hasRejectedDocs) {
          this.$swal({
            icon: "error",
            title: "Your document has been rejected",
          });
        }
        if (status == "REJECTED") {
          this.$swal({
            icon: "error",
            title: "Your status is rejected",
          });
        }
      }
    },
    async getProfile() {
      try {
        const { data } = await this.$http.get("panel/profile/partner");

        await localStorage.setItem(
          "userData",
          JSON.stringify({
            ...data.partner.data,
            documents: data.documents.data,
            type: "partner",
          })
        );
        await this.$store.dispatch("auth/setUserData", {
          ...data.partner.data,
          documents: data.documents.data,
          type: "partner",
        });
      } catch (err) {}
    },
  },
};
</script>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.bg-register-gradient-info {
  background-image: linear-gradient(47deg, #fbad25, #ffc259);
}
.bg-register-gradient-danger {
  background-image: linear-gradient(47deg, #e54d58, #ad0462);
}
</style>
